import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PayCashCoinIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M12.79 11.18V8.87C13.46 9.02 13.9 9.33 14.24 9.7L15.51 8.56C14.9 7.86 14.08 7.43 12.96 7.31V6H11.37V7.31C9.56997 7.52 8.60997 8.49 8.60997 9.95C8.60997 11.3 9.45997 12.22 11.55 12.65V15.16C10.77 15.05 10.12 14.67 9.58997 14.12L8.33997 15.26C9.03997 16.03 9.96997 16.6 11.37 16.72V18H12.96V16.66C14.81 16.35 15.68 15.2 15.68 13.83C15.68 12.46 14.75 11.62 12.8 11.17L12.79 11.18ZM11.55 10.9C10.84 10.7 10.53 10.43 10.53 9.9C10.53 9.37 10.84 8.98 11.55 8.84V10.9ZM12.79 15.13V12.93C13.58 13.17 13.75 13.58 13.75 13.99C13.75 14.52 13.44 14.95 12.79 15.13Z"
        fill={color}
      />
      <path
        d="M12 0.25C5.52 0.25 0.25 5.52 0.25 12C0.25 18.48 5.52 23.75 12 23.75C18.48 23.75 23.75 18.48 23.75 12C23.75 5.52 18.48 0.25 12 0.25ZM12 22.25C6.35 22.25 1.75 17.65 1.75 12C1.75 6.35 6.35 1.75 12 1.75C17.65 1.75 22.25 6.35 22.25 12C22.25 17.65 17.65 22.25 12 22.25Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PayCashCoinIcon.displayName = 'PayCashCoinIcon';
